/* eslint-disable import/no-unresolved */
import CustomTextField from "src/shared/CustomTextField";

interface Props {
  formik: any;
}

function BankDetails({ formik }: Props) {
  return (
    <div>
      <p className="text-daintree font-montserrat text-sm font-medium mb-6">
        Kindly provide the name of the Bank, Branch and the account number through which you will be
        paying the premium
      </p>
      <div className="flex flex-col md:flex-row">
        <div className="w-full md:w-222/1000 mr-8.75 mb-6 md:mb-0">
          <CustomTextField
            requiredStar
            label="Name Of The Bank"
            className=""
            // onChange={handleChange("bankDetails.nameOfTheBank")}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.bankDetails?.nameOfTheBank}
            name="bankDetails.nameOfTheBank"
            error={formik.errors.bankDetails?.nameOfTheBank}
            touched={formik.touched.bankDetails?.nameOfTheBank}
          />
        </div>
        <div className="w-full md:w-222/1000 mr-8.75 mb-6 md:mb-0">
          <CustomTextField
            requiredStar
            label="Branch"
            className=""
            // onChange={handleChange("bankDetails.branch")}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.bankDetails?.branch}
            name="bankDetails.branch"
            error={formik.errors.bankDetails?.branch}
            touched={formik.touched.bankDetails?.branch}
          />
        </div>
        <div className="w-full md:w-222/1000">
          <CustomTextField
            requiredStar
            label="Account Number"
            className=""
            // onChange={handleChange("bankDetails.accountNumber")}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.bankDetails?.accountNumber}
            name="bankDetails.accountNumber"
            error={formik.errors.bankDetails?.accountNumber}
            touched={formik.touched.bankDetails?.accountNumber}
          />
        </div>
      </div>
    </div>
  );
}

export default BankDetails;
